import * as React from 'react'
import { ReactElement } from 'react'
import { Route, Switch } from 'react-router'
import AddFile from './File/AddFile'
import EditFile from './File/EditFile'
import ViewFile from './File/ViewFile'
import ViewFileV2 from '../v2/pages/File/ViewFile'
import FileOverview from './File/FileOverview'
import useNewVersionPreference from '../hooks/useNewVersionPreference'

export default function Files(): ReactElement {
    const { newVersion } = useNewVersionPreference()

    return (
        <Switch>
            <Route exact path="/file" component={FileOverview} />
            <Route path="/file/add" component={AddFile} />
            <Route path="/file/:id/edit" component={EditFile} />
            {/*We cannot change the file ID param to :id, because it can encapsulate any route that already uses // the :id param for its own entity.*/}
            {!newVersion && <Route path="/file/:fileId" component={ViewFile} />}
            {newVersion && <Route path="/file/:fileId/:tab?/:action?" component={ViewFileV2} />}
        </Switch>
    )
}
